import React from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";


const serviceData = {
  "personal-injury": {
    title: "Personal Injury & Public Liability",
    subtitle: "Injured? We fight for your compensation.",
    intro:
      "We assist clients who have suffered injuries due to negligence, accidents, or unsafe environments. Our goal is to ensure you receive fair compensation while we handle the legal complexities.",
    items: [
      {
        title: "Road Accident Claims",
        desc: "Assistance with claims involving the Road Accident Fund (RAF), including passenger, driver, and pedestrian injuries.",
      },
      {
        title: "Workplace Injuries",
        desc: "Helping employees claim compensation for injuries sustained in the workplace and dealing with employer or insurer disputes.",
      },
      {
        title: "Public Liability",
        desc: "Claims arising from injuries in public spaces, shopping centres, or private properties due to negligence.",
      },
      {
        title: "Medical Negligence",
        desc: "Legal support for patients harmed by medical errors, misdiagnosis, or negligence by healthcare professionals.",
      },
    ],
  },

  "employment-law": {
    title: "Employment & Labour Law",
    subtitle: "Protecting your workplace rights.",
    intro:
      "We provide comprehensive legal support to both employees and employers, ensuring compliance with labour laws and fair workplace practices.",
    items: [
      {
        title: "Unfair Dismissal",
        desc: "Representation at the CCMA and Labour Court for wrongful termination disputes.",
      },
      {
        title: "Employment Contracts",
        desc: "Drafting, reviewing, and advising on employment agreements and policies.",
      },
      {
        title: "Workplace Disputes",
        desc: "Handling grievances, disciplinary hearings, and conflict resolution.",
      },
      {
        title: "Retrenchments & Restructuring",
        desc: "Guidance on fair procedures during retrenchments and organisational changes.",
      },
    ],
  },

  "marriage-property": {
    title: "Marriage & Matrimonial Property",
    subtitle: "Protecting your assets and rights in marriage.",
    intro:
      "We assist clients in navigating the legal aspects of marriage, divorce, and property regimes, ensuring clarity and protection of assets.",
    items: [
      {
        title: "Antenuptial Contracts",
        desc: "Drafting and registering prenuptial agreements tailored to your needs.",
      },
      {
        title: "Divorce Proceedings",
        desc: "Guidance and representation in contested and uncontested divorces.",
      },
      {
        title: "Property Division",
        desc: "Ensuring fair distribution of assets during divorce or separation.",
      },
      {
        title: "Maintenance & Support",
        desc: "Advising on spousal and child maintenance obligations.",
      },
    ],
  },

  "estates-wills": {
    title: "Estates, Trusts & Wills",
    subtitle: "Securing your legacy for future generations.",
    intro:
      "We provide expert estate planning services to protect your assets and ensure your wishes are carried out effectively.",
    items: [
      {
        title: "Drafting Wills",
        desc: "Creating legally sound wills tailored to your personal circumstances.",
      },
      {
        title: "Estate Planning",
        desc: "Strategic planning to minimise disputes and ensure efficient asset distribution.",
      },
      {
        title: "Deceased Estates",
        desc: "Administration and winding up of estates in accordance with the law.",
      },
      {
        title: "Trust Formation",
        desc: "Establishing and managing trusts to protect assets and beneficiaries.",
      },
    ],
  },

  "consumer-protection": {
    title: "Consumer Protection",
    subtitle: "Defending your rights as a consumer.",
    intro:
      "We assist clients in enforcing their rights under consumer protection laws and resolving disputes with suppliers and service providers.",
    items: [
      {
        title: "Defective Goods & Services",
        desc: "Claims relating to faulty products or poor service delivery.",
      },
      {
        title: "Contract Disputes",
        desc: "Resolving disputes arising from unfair or misleading agreements.",
      },
      {
        title: "Refunds & Returns",
        desc: "Assisting with enforcing your right to refunds or replacements.",
      },
      {
        title: "Consumer Complaints",
        desc: "Representation in disputes with businesses and regulatory bodies.",
      },
    ],
  },

  "family-law": {
    title: "Family Law & Divorce",
    subtitle: "Guiding you through sensitive family matters.",
    intro:
      "We provide compassionate and professional legal support in family-related matters, ensuring the best outcomes for you and your loved ones.",
    items: [
      {
        title: "Divorce & Separation",
        desc: "Handling both contested and uncontested divorce proceedings.",
      },
      {
        title: "Child Custody",
        desc: "Assisting with custody arrangements that prioritise the best interests of the child.",
      },
      {
        title: "Maintenance Claims",
        desc: "Securing fair child and spousal maintenance orders.",
      },
      {
        title: "Domestic Violence Matters",
        desc: "Legal protection and assistance in cases involving abuse or harassment.",
      },
    ],
  },
};

const ServiceDetail = () => {
  const { slug } = useParams();
  const service = serviceData[slug];

  if (!service) return <div>Service not found</div>;

  return (
    <div
      style={{
        backgroundImage: "url('/banner-image.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
      }}
    >
<section
  className="position-relative text-white d-flex align-items-center"
  style={{ height: "50vh" }}
>
  {/* Overlay */}
  <div
    className="position-absolute w-100 h-100"
    style={{ background: "#76421aa2" }}
  ></div>

  <Container className="position-relative">
    <Row className="align-items-center">

      {/* 🔥 LEFT - LOGO */}
      <Col lg={6} className="d-none d-lg-flex align-items-center">
        <img
          src="/logo-removebg-preview.png"
          alt="Logo"
          style={{
            maxWidth: "400px",
            width: "80%",
            height: "auto",
          }}
        />
      </Col>

      {/* 🔥 RIGHT - TEXT */}
      <Col lg={6} className="text-lg-end text-center">
        <h1
          className="fw-bold mb-2"
          style={{
            fontFamily: "'Calisto MT', 'Times New Roman', serif",
            color: "#222",
            fontSize: "2.2rem",
          }}
        >
          {service.title}
        </h1>

        <p
          style={{
            fontFamily: "'Calisto MT', 'Times New Roman', serif",
            color: "#444",
            fontSize: "1rem",
          }}
        >
          {service.subtitle}
        </p>

        <Link to="/contact">
          <button
            className="btn fw-bold rounded-pill text-white px-4 py-2"
            style={{ backgroundColor: "#4482fc" }}
          >
            Get in Touch
          </button>
        </Link>
      </Col>

    </Row>
  </Container>
</section>

      {/* 🔥 CONTENT */}
      <section style={{ background: "rgba(255,255,255,0.95)" }}>
        <Container className="py-5">

          <Row className="justify-content-center mb-5">
            <Col lg={10}>
              <p style={{ color: "#8b5e3c" }}>{service.intro}</p>
            </Col>
          </Row>

          <Row className="justify-content-center mb-5">
            <Col lg={10}>
              {service.items.map((item, i) => (
                <div key={i} className="mb-4 pb-4 border-bottom">
                  <h5 style={{ color: "#4482fc" }}>{item.title}</h5>
                  <p>{item.desc}</p>
                </div>
              ))}
            </Col>
          </Row>


          {/* Call to Action Box */}
          <div
            className="p-4 mt-4 rounded shadow-sm text-center"
            style={{ backgroundColor: "#f8f9fa", border: "0px" }}
          >
            <h5 style={{ color: "#8b5e3c" }}>Need Assistance?</h5>
            {/* <p style={{ marginBottom: "1rem" }}>
              Whether you are purchasing property, managing a sectional title scheme, or involved in a property dispute, our expert legal team is here to guide and protect you every step of the way.
            </p> */}
            <br />
            <a
              href="/#contact"
              className="btn"
              style={{
                backgroundColor: "#4482fc",
                color: "#fff",
                fontWeight: "600",
                padding: "0.6rem 1.5rem",
                borderRadius: "30px",
                fontSize: "1.1rem",
              }}
            >
              Schedule Consultation
            </a>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default ServiceDetail;